<script>
  import { onMount, onDestroy } from 'svelte'

  const images = [
    { src: '/home_img/image1.png', alt: 'Bosque' },
    { src: '/home_img/image4.png', alt: 'Desierto' },
    { src: '/home_img/image7.png', alt: 'Nieve' },
  ]
  let current = 0
  let transitioning = false
  let timer

  const INTERVALO = 6000

  function iniciarAuto() {
    detenerAuto()
    timer = setInterval(() => next(), INTERVALO)
  }

  function detenerAuto() {
    clearInterval(timer)
  }

  function goTo(index) {
    if (transitioning) return
    current = ((index % images.length) + images.length) % images.length
  }

  function next() {
    if (transitioning) return
    transitioning = true
    current = (current + 1) % images.length
    setTimeout(() => transitioning = false, 400)
  }

  function prev() {
    if (transitioning) return
    transitioning = true
    current = (current - 1 + images.length) % images.length
    setTimeout(() => transitioning = false, 400)
  }

  function pausar() { detenerAuto() }
  function reanudar() { iniciarAuto() }

  onMount(() => iniciarAuto())
  onDestroy(() => detenerAuto())
</script>

<div
  class="carousel-wrapper"
  role="region"
  aria-label="Carrusel de im�genes"
  on:mouseenter={pausar}
  on:mouseleave={reanudar}
  on:focusin={pausar}
  on:focusout={reanudar}
>
  <div class="viewport">
    <div class="track" style="transform: translateX(-{current * 100}%)">
      {#each images as img, i}
        <div class="slide" role="group" aria-roledescription="slide" aria-label="Imagen {i + 1} de {images.length}">
          <img src={img.src} alt={img.alt} loading={i === 0 ? 'eager' : 'lazy'} />
        </div>
      {/each}
    </div>
  </div>

  <button class="btn btn--prev" on:click={prev} aria-label="Anterior">&#10094;</button>
  <button class="btn btn--next" on:click={next} aria-label="Siguiente">&#10095;</button>

  <div class="dots" role="tablist" aria-label="Navegaci�n de diapositivas">
    {#each images as _, i}
      <button
        class="dot"
        class:dot--active={current === i}
        on:click={() => goTo(i)}
        role="tab"
        aria-selected={current === i}
        aria-label="Ir a imagen {i + 1}"
      ></button>
    {/each}
  </div>
</div>

<style>
  .carousel-wrapper {
    position: relative;
    width: 100%;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  }

  .viewport {
    overflow: hidden;
    
  }

  .track {
    display: flex;
    transition: transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    will-change: transform;
  }

  .slide {
    min-width: 100%;
  }

  .slide img {
    width: 100%;
    height: auto;
    display: block;
  }

  .btn {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.8);
    border: none;
    width: 44px;
    height: 44px;
    border-radius: 50%;
    font-size: 1.2rem;
    cursor: pointer;
    transition: background 0.2s, transform 0.2s;
    z-index: 2;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(4px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }
  .btn:hover { background: rgba(255, 255, 255, 0.95); transform: translateY(-50%) scale(1.05); }
  .btn--prev  { left: 12px; }
  .btn--next  { right: 12px; }

  .dots {
    position: absolute;
    bottom: 14px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 8px;
    z-index: 2;
  }

  .dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    border: none;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    transition: background 0.3s, transform 0.2s;
    padding: 0;
  }
  .dot:hover { background: rgba(255, 255, 255, 0.8); }
  .dot--active {
    background: #fff;
    transform: scale(1.3);
  }

  @media (max-width: 600px) {
    .btn { width: 36px; height: 36px; font-size: 1rem; }
    .btn--prev { left: 6px; }
    .btn--next { right: 6px; }
    .dot { width: 8px; height: 8px; }
  }
</style>